export const sections = state => state.PassportReducer.sections
export const template = state => state.PassportReducer.template
export const items = state => state.PassportReducer.items
export const search = state => state.PassportReducer.search
export const parts = state => state.PassportReducer.parts
export const passportParent = state => state.PassportReducer.passportParent
export const passportSection = state => state.PassportReducer.passportSection
export const value = state => state.PassportReducer.value
